import 'physician/physician.order'
import 'styles/physician/catalog-print.css'
import commercialTest from 'physician/commercialTest'

window.Physician.commercialTest = commercialTest
